<template lang='pug'>
.content
  grid(
  :model="getModel"
  name='',
  label='Pair'
  desc=''
  :views='false'
  layout='frame'
  search=true
  resizing=false
  :endpoint='api.$.BUAndCC.getBusinessUnitsAndCostCenters'
  :actions='actions'
  @removeRow='removePair'
  @removeRows='removePairs'
  @changeRow='editPair'
  remove-many
  fit-columns
  ref='PairedBUCCGrid'
  :editFullRowOnAdd="true"
)
    span(slot='additionalButtons')
        ed-button.btn.btn-actionbar(
          @click="addBUCC") Add BU & CC Pair
</template>
<script>
import Grid from '@/components/Grid'
import {remove} from '@/components/Grid/cells/actions'
import { EventBus } from '@/event-bus'
import events from '@/core/events/events'
import BUCCModel from './BUCCModel.js'

export default {
  components: {
    Grid
  },

  data() {
    return {
      BUCCModel,
      actions: [remove],
      list: utils.collection.list
    }
  },
  computed: {
    getModel() {
      return BUCCModel.get()
    }
  },
  created() {
    EventBus.$on(events.BU_CC.REFRESH, r => {
      this.refresh()
    })
  },
  methods: {
    editPair (payload, success, fail) {
      //
      if (!this.validBUCC(payload.data)) {
        fail('Invalid Business Unit & Cost Center pair')
      } else {
        this.api.post(this.api.$.BUAndCC.saveBuAndCcPair, payload.data)
          .then(r => success(r))
          .catch(e => fail())
      }
    },
    removePair(payload, success, fail) {
      //
      var id = +payload.data.Id
      this.api.delete(this.api.$.BUAndCC.deleteBuAndCcPair + '/' + id, id)
        .then(r => success())
        .catch(e => fail('Something went wrong. Cannot delete the Business Unit'))
    },
    removePairs (payload) {
      //
      var pairIds = []
      payload.rows.forEach(element => {
        pairIds.push(element.data.Id)
      })
      var p = {
        IDs: pairIds
      }
      this.api.post(this.api.$.BUAndCC.deleteBuAndCcPairs, p).then(this.validateDeletePairs)
    },

    addBUCC() {
      this.$refs.PairedBUCCGrid.addRow({})
    },

    validBUCC(data) {
      var isValid = false
      if (data.CostCenterNo && data.CostCenterNo.trim() !== '' && data.BusinessUnitName && data.BusinessUnitName.trim() !== '') {
        isValid = true
      }
      return isValid
    },

    refresh() {
      this.$refs.PairedBUCCGrid.quickSearch()
      this.$refs.PairedBUCCGrid.onSelectAll(false)
    },

    validateDeletePairs(r) {
      if (r.data.Errors.length !== 0) {
        alert('Something went wrong. Cannot delete the Business Units.')
      }
      EventBus.$emit(events.BU_CC.REFRESH)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_modules/BusinessUnitsAndCostCenters/BU-CC-list/index.vue